module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kyushu-4-f745506a1d38f567bf305c27d9ae96c7.png";